/**
 * Data layer for `flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou`. Thin typed fetch wrappers over /api/v1/flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouResponse {
	count: number;
	items: FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouRow[];
}

export interface CreateFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouResponse>(res);
}

export async function create(body: CreateFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouBody): Promise<FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys = {
	all: ["flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou"] as const,
	list: () => [...flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys.all] as const,
	detail: (id: string) => [...flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys.all, id] as const,
};
